export default {
  path: '/my',
  name:'/my',
  meta: {
    title: '我的',
    tab:true
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/my`),
}



// WEBPACK FOOTER //
// ./src/views/My/router.js